type TranslateFn = (key: string, options?: { defaultValue?: string }) => string;

/**
 * Translate `key`, but when it is not yet defined in the translation backend,
 * show the French fallback FOLLOWED BY the key itself in brackets — e.g.
 * `Champs [fieldVisibility.tab.fields]`. This lets the team see exactly which
 * key to register in the DB. As soon as the key exists in the API, its value
 * wins and the `[key]` suffix disappears automatically.
 *
 * Use ONLY for brand-new keys not yet present in the translation backend.
 */
export function tWithKey(t: TranslateFn, key: string, fr: string): string {
  return t(key, { defaultValue: `${fr} (${key})` });
}
